import type { Tab } from '../../custom-tab-bar/type.d.ts';

export const route = {
  component: () => import('./page.vue'),
  path: '/hotel/help',
  name: 'hotel-help',
  meta: {
    title: '帮助',
    auth: true,
    needPhone: false,
    wechat: {
      AppMessageShare: false,
      TimelineShare: false,
      baseAuth: true,
    },
  },
};

export const tab: Tab = {
  label: route.meta.title,
  icon: 'question-o',
  to: {
    name: route.name,
  },
};
